import { Component, type ErrorInfo, type ReactNode } from "react"
import { captureException } from "@/lib/analytics"

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    captureException(error, { component_stack: info.componentStack })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="p-4 text-sm text-gray-600" role="alert">
            Something went wrong. Please refresh the page.
          </div>
        )
      )
    }
    return this.props.children
  }
}
